import React, { useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Input,
    Label,
    Button,
    Table,
    CardHeader,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const PayrollReport = () => {
    // State for selected date range and search query
    const [selectedDateRange, setSelectedDateRange] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    // State to store filtered payroll reports
    const [filteredPayrollReports, setFilteredPayrollReports] = useState([]);

    // Dummy data for payroll reports (January, February, March 2025)
    const payrollReports = [
        // January 2025
        {
            siNo: 1,
            name: "John Doe",
            role: "Teacher",
            designation: "Senior Lecturer",
            monthYear: "2025-01-01",
            payslipNumber: "PS001",
            basicSalary: 40000,
            earnings: 5000,
            deductions: 2000,
            grossSalary: 45000,
            tax: 5000,
            netSalary: 40000,
        },
        {
            siNo: 2,
            name: "Jane Smith",
            role: "Librarian",
            designation: "Head Librarian",
            monthYear: "2025-01-05",
            payslipNumber: "PS002",
            basicSalary: 35000,
            earnings: 4000,
            deductions: 1500,
            grossSalary: 39000,
            tax: 4000,
            netSalary: 35000,
        },
        {
            siNo: 3,
            name: "Alice Johnson",
            role: "Accountant",
            designation: "Senior Accountant",
            monthYear: "2025-01-10",
            payslipNumber: "PS003",
            basicSalary: 45000,
            earnings: 6000,
            deductions: 2500,
            grossSalary: 51000,
            tax: 6000,
            netSalary: 45000,
        },
        {
            siNo: 4,
            name: "Bob Brown",
            role: "Receptionist",
            designation: "Front Desk Executive",
            monthYear: "2025-01-25",
            payslipNumber: "PS004",
            basicSalary: 30000,
            earnings: 3000,
            deductions: 1000,
            grossSalary: 33000,
            tax: 3000,
            netSalary: 30000,
        },
        {
            siNo: 5,
            name: "Charlie Davis",
            role: "Designer",
            designation: "Graphic Designer",
            monthYear: "2025-01-15",
            payslipNumber: "PS005",
            basicSalary: 38000,
            earnings: 4500,
            deductions: 2000,
            grossSalary: 42500,
            tax: 4500,
            netSalary: 38000,
        },

        // February 2025
        {
            siNo: 6,
            name: "Eva Green",
            role: "Teacher",
            designation: "Junior Lecturer",
            monthYear: "2025-02-01",
            payslipNumber: "PS006",
            basicSalary: 32000,
            earnings: 3000,
            deductions: 1000,
            grossSalary: 35000,
            tax: 3000,
            netSalary: 32000,
        },
        {
            siNo: 7,
            name: "Frank White",
            role: "Librarian",
            designation: "Assistant Librarian",
            monthYear: "2025-02-05",
            payslipNumber: "PS007",
            basicSalary: 28000,
            earnings: 2000,
            deductions: 800,
            grossSalary: 30000,
            tax: 2000,
            netSalary: 28000,
        },
        {
            siNo: 8,
            name: "Grace Black",
            role: "Accountant",
            designation: "Junior Accountant",
            monthYear: "2025-02-10",
            payslipNumber: "PS008",
            basicSalary: 40000,
            earnings: 5000,
            deductions: 2000,
            grossSalary: 45000,
            tax: 5000,
            netSalary: 40000,
        },
        {
            siNo: 9,
            name: "Henry Blue",
            role: "Receptionist",
            designation: "Front Desk Assistant",
            monthYear: "2025-02-15",
            payslipNumber: "PS009",
            basicSalary: 25000,
            earnings: 2000,
            deductions: 500,
            grossSalary: 27000,
            tax: 2000,
            netSalary: 25000,
        },
        {
            siNo: 10,
            name: "Ivy Yellow",
            role: "Designer",
            designation: "UI/UX Designer",
            monthYear: "2025-02-20",
            payslipNumber: "PS010",
            basicSalary: 36000,
            earnings: 4000,
            deductions: 1500,
            grossSalary: 40000,
            tax: 4000,
            netSalary: 36000,
        },

        // March 2025
        {
            siNo: 11,
            name: "John Doe",
            role: "Teacher",
            designation: "Senior Lecturer",
            monthYear: "2025-03-01",
            payslipNumber: "PS011",
            basicSalary: 40000,
            earnings: 5000,
            deductions: 2000,
            grossSalary: 45000,
            tax: 5000,
            netSalary: 40000,
        },
        {
            siNo: 12,
            name: "Jane Smith",
            role: "Librarian",
            designation: "Head Librarian",
            monthYear: "2025-03-05",
            payslipNumber: "PS012",
            basicSalary: 35000,
            earnings: 4000,
            deductions: 1500,
            grossSalary: 39000,
            tax: 4000,
            netSalary: 35000,
        },
        {
            siNo: 13,
            name: "Alice Johnson",
            role: "Accountant",
            designation: "Senior Accountant",
            monthYear: "2025-03-10",
            payslipNumber: "PS013",
            basicSalary: 45000,
            earnings: 6000,
            deductions: 2500,
            grossSalary: 51000,
            tax: 6000,
            netSalary: 45000,
        },
        {
            siNo: 14,
            name: "Bob Brown",
            role: "Receptionist",
            designation: "Front Desk Executive",
            monthYear: "2025-03-15",
            payslipNumber: "PS014",
            basicSalary: 30000,
            earnings: 3000,
            deductions: 1000,
            grossSalary: 33000,
            tax: 3000,
            netSalary: 30000,
        },
        {
            siNo: 15,
            name: "Charlie Davis",
            role: "Designer",
            designation: "Graphic Designer",
            monthYear: "2025-03-20",
            payslipNumber: "PS015",
            basicSalary: 38000,
            earnings: 4500,
            deductions: 2000,
            grossSalary: 42500,
            tax: 4500,
            netSalary: 38000,
        },
    ];

    // Handle date range selection
    const handleDateRangeChange = (e) => {
        const range = e.target.value;
        setSelectedDateRange(range);
        filterPayrollReports(range, searchQuery);
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        filterPayrollReports(selectedDateRange, query);
    };

    // Filter payroll reports based on date range and search query
    const filterPayrollReports = (dateRange, query) => {
        let filtered = payrollReports;

        // Filter by date range
        if (dateRange) {
            const today = new Date();
            const startDate = new Date();

            switch (dateRange) {
                case "today":
                    startDate.setHours(0, 0, 0, 0);
                    break;
                case "thisWeek":
                    startDate.setDate(today.getDate() - today.getDay());
                    break;
                case "lastWeek":
                    startDate.setDate(today.getDate() - today.getDay() - 7);
                    break;
                case "thisMonth":
                    startDate.setDate(1);
                    break;
                case "lastMonth":
                    startDate.setMonth(today.getMonth() - 1, 1);
                    break;
                case "3Months":
                    startDate.setMonth(today.getMonth() - 3);
                    break;
                case "6Months":
                    startDate.setMonth(today.getMonth() - 6);
                    break;
                case "1Year":
                    startDate.setFullYear(today.getFullYear() - 1);
                    break;
                case "2Years":
                    startDate.setFullYear(today.getFullYear() - 2);
                    break;
                default:
                    break;
            }

            filtered = filtered.filter((report) => {
                const reportDate = new Date(report.monthYear);
                return reportDate >= startDate;
            });
        }

        // Filter by search query
        if (query) {
            filtered = filtered.filter(
                (report) =>
                    report.name.toLowerCase().includes(query.toLowerCase()) ||
                    report.role.toLowerCase().includes(query.toLowerCase()) ||
                    report.designation.toLowerCase().includes(query.toLowerCase()) ||
                    report.payslipNumber.toLowerCase().includes(query.toLowerCase())
            );
        }

        setFilteredPayrollReports(filtered);
    };

    // Calculate grand totals
    const grandTotalBasicSalary = filteredPayrollReports.reduce((total, report) => total + report.basicSalary, 0);
    const grandTotalEarnings = filteredPayrollReports.reduce((total, report) => total + report.earnings, 0);
    const grandTotalDeductions = filteredPayrollReports.reduce((total, report) => total + report.deductions, 0);
    const grandTotalGrossSalary = filteredPayrollReports.reduce((total, report) => total + report.grossSalary, 0);
    const grandTotalTax = filteredPayrollReports.reduce((total, report) => total + report.tax, 0);
    const grandTotalNetSalary = filteredPayrollReports.reduce((total, report) => total + report.netSalary, 0);

    // Breadcrumb items
    const breadcrumbItems = [
        { title: "Reports", link: "/" },
        { title: "Finance Reports", link: "/" },
        { title: "Payroll Report", link: "/admin/payroll-report" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Payroll Report" breadcrumbItems={breadcrumbItems} />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center flex-wrap">
                                    <h4 className="card-title mb-0 flex-grow-1">Payroll Report</h4>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        {/* Date Range Select Input */}
                                        <Col lg={3}>
                                            <Label>Date Range</Label>
                                            <Input
                                                type="select"
                                                value={selectedDateRange}
                                                onChange={handleDateRangeChange}
                                            >
                                                <option value="">Select Date Range</option>
                                                <option value="today">Today</option>
                                                <option value="thisWeek">This Week</option>
                                                <option value="lastWeek">Last Week</option>
                                                <option value="thisMonth">This Month</option>
                                                <option value="lastMonth">Last Month</option>
                                                <option value="3Months">Last 3 Months</option>
                                                <option value="6Months">Last 6 Months</option>
                                                <option value="1Year">Last 1 Year</option>
                                                <option value="2Years">Last 2 Years</option>
                                            </Input>
                                        </Col>

                                        {/* Search Input */}
                                        <Col lg={6}>
                                            <Label>Search</Label>
                                            <Input
                                                type="text"
                                                placeholder="Search by Name, Role, Designation, or Payslip Number"
                                                value={searchQuery}
                                                onChange={handleSearchChange}
                                            />
                                        </Col>

                                        {/* Search Button */}
                                        <Col lg={3} className="d-flex align-items-end">
                                            <Button color="primary" onClick={() => filterPayrollReports(selectedDateRange, searchQuery)}>
                                                Search
                                            </Button>
                                        </Col>
                                    </Row>

                                    {/* Payroll Report Table */}
                                    <Row className="mt-4">
                                        <Col lg={12}>
                                            {filteredPayrollReports.length > 0 ? (
                                                <Table striped>
                                                    <thead>
                                                        <tr>
                                                            <th>SI No</th>
                                                            <th>Name</th>
                                                            <th>Role</th>
                                                            <th>Designation</th>
                                                            <th>Month-Year</th>
                                                            <th>Payslip Number</th>
                                                            <th>Basic Salary</th>
                                                            <th>Earnings</th>
                                                            <th>Deductions</th>
                                                            <th>Gross Salary</th>
                                                            <th>Tax</th>
                                                            <th>Net Salary</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredPayrollReports.map((report, index) => (
                                                            <tr key={report.siNo}>
                                                                {/* Dynamically assign SI No based on the filtered list index */}
                                                                <td>{index + 1}</td>
                                                                <td>{report.name}</td>
                                                                <td>{report.role}</td>
                                                                <td>{report.designation}</td>
                                                                <td>{report.monthYear}</td>
                                                                <td>{report.payslipNumber}</td>
                                                                <td>{report.basicSalary}</td>
                                                                <td>{report.earnings}</td>
                                                                <td>{report.deductions}</td>
                                                                <td>{report.grossSalary}</td>
                                                                <td>{report.tax}</td>
                                                                <td>{report.netSalary}</td>
                                                            </tr>
                                                        ))}
                                                        {/* Grand Totals Row */}
                                                        <tr style={{ fontWeight: "bold" }}>
                                                            <td colSpan="6">Grand Total</td>
                                                            <td>{grandTotalBasicSalary}</td>
                                                            <td>{grandTotalEarnings}</td>
                                                            <td>{grandTotalDeductions}</td>
                                                            <td>{grandTotalGrossSalary}</td>
                                                            <td>{grandTotalTax}</td>
                                                            <td>{grandTotalNetSalary}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <div className="text-center">
                                                    <p>No Record Found</p>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PayrollReport;